import { render, staticRenderFns } from "./AffectationList.vue?vue&type=template&id=fc73cda8&scoped=true&"
import script from "./AffectationList.vue?vue&type=script&lang=js&"
export * from "./AffectationList.vue?vue&type=script&lang=js&"
import style0 from "./AffectationList.vue?vue&type=style&index=0&id=fc73cda8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc73cda8",
  null
  
)

export default component.exports